import { StrictMode, useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { Terminal } from "./Terminal.tsx";
import "./styles.css";

type AuthState = "loading" | "authenticated" | "anonymous";

function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  return (
    <main className="login-page">
      <form
        className="login-card"
        onSubmit={async (event) => {
          event.preventDefault();
          setSubmitting(true);
          setError("");
          const response = await fetch("/api/auth/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ password }),
          });
          setSubmitting(false);
          if (response.ok) onSuccess();
          else setError(response.status === 429 ? "Слишком много попыток" : "Неверный пароль");
        }}
      >
        <span className="login-mark">T</span>
        <h1>T-Invest Terminal</h1>
        <p>Персональный read-only доступ</p>
        <label>
          <span>Пароль</span>
          <input
            autoFocus
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            value={password}
          />
        </label>
        {error && <div className="login-error" role="alert">{error}</div>}
        <button disabled={submitting || password.length === 0} type="submit">
          {submitting ? "Проверяем…" : "Войти"}
        </button>
      </form>
    </main>
  );
}

function App() {
  const [auth, setAuth] = useState<AuthState>("loading");

  const checkAuth = useCallback(async () => {
    const response = await fetch("/api/status");
    setAuth(response.status === 401 ? "anonymous" : "authenticated");
  }, []);

  useEffect(() => void checkAuth(), [checkAuth]);

  if (auth === "loading") return <main className="splash">Подключение…</main>;
  if (auth === "anonymous") return <Login onSuccess={() => setAuth("authenticated")} />;

  return <Terminal onLogout={async () => {
    await fetch("/api/auth/logout", { method: "POST" });
    setAuth("anonymous");
  }} />;
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element is missing");
createRoot(root).render(<StrictMode><App /></StrictMode>);
